<template>
  <!-- 使用 van-popup 替代 el-dialog -->
  <van-popup v-model="open" position="bottom" :close-on-click-overlay="false" round closeable>
    <div class="dialog-content">
      <!-- 标题 -->
      <div class="dialog-header">
        <h3>{{ title }}</h3>
      </div>

      <!-- 表单内容 -->
      <div class="dialog-body">
        <van-cell-group inset>
          <!-- 图片上传 -->
          <van-cell title="图片" required />
          <van-field>
            <template #input>
              <image-upload v-model="form.url" :isShowTip="true" :limit="1" />
            </template>
          </van-field>
        </van-cell-group>
      </div>

      <!-- 底部按钮 -->
      <div class="dialog-footer">
        <van-button block type="primary" @click="submitForm">确 定</van-button>
        <van-button block @click="cancel" style="margin-top: 10px;">取 消</van-button>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { faceLibrarySearch } from "@/api/faceDatabase";

export default {
  components: {},
  data() {
    return {
      title: "",
      open: false,
      form: {
        platForm: null,
        url: ''
      },
      rules: {} // 保留 rules 结构（虽然 Vant 不用，但可留空兼容逻辑）
    };
  },
  methods: {
    addCreateForm(platForm) {
      this.reset();
      this.open = true;
      this.form.platForm = platForm;
      this.title = '查询';
    },
    reset() {
      this.form = {
        platForm: null,
        url: ''
      };
    },
    submitForm() {
      // 模拟表单校验（如果 image-upload 有校验逻辑，可在此扩展）
      if (!this.form.url) {
        this.$toast.fail('请上传图片');
        return;
      }

      const data = {
        platForm: this.form.platForm,
        url: this.form.url
      };

      faceLibrarySearch(data)
        .then(response => {
          this.open = false;
          if (response.data.code === 200) {
            console.log(response);
            this.$toast.success("查询成功");
            this.$emit('ok', response.data.data);
          } else {
            this.$toast.fail(response.data.msg);
          }
        })
        .catch(() => {
          this.$toast.fail("查询失败");
        });
    },
    cancel() {
      this.open = false;
    }
  }
};
</script>

<style scoped>
.dialog-content {
  font-size: 14px;
  background-color: #fff;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.dialog-header {
  padding: 16px;
  text-align: center;
  border-bottom: 1px solid #f2f2f2;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.dialog-body {
  padding: 0 0 16px;
}

/* 图片上传项样式 */
.van-cell {
  padding: 12px 16px;
}

.van-cell__title {
  font-weight: 600;
  color: #333;
}

.van-field {
  padding: 12px 16px;
}

.dialog-footer {
  padding: 12px 16px 20px;
  background-color: #fff;
  border-top: 1px solid #f2f2f2;
}

/* 移动端按钮更友好 */
.van-button--block {
  height: 44px;
  font-size: 16px;
  font-weight: 500;
}
</style>